// Select dropdown behavior for grid columns.
//
// Uses AG Grid's built-in select cell editor with a fixed list of options.
//
// Column def:  { field: "dealType", behavior: "select" }
// Config:      data-grid-behaviors-value='{"select":{"options":[{"value":"wholesale","label":"Wholesale"},...]}}'
//
// The cell displays the label; the underlying value is stored in row data.

import { createBehavior } from "./create_behavior"

export const select = createBehavior({
  cellEditor: "agSelectCellEditor",

  cellEditorParams(config) {
    return {
      values: (config.options || []).map((o) => o.value)
    }
  },

  valueFormatter({ value, config }) {
    if (!value) return ""
    const option = (config.options || []).find((o) => o.value === value)
    return option ? option.label : value
  }
})
